import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { BlockPanel } from '@appfolio/react-gears';

import tokens from '../lib/tokens';
import logger from '../lib/logger';

import RevokeForm from './RevokeForm';

function RevokePage({ history }) {
  const [errors, setErrors] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    // Mimic componentDidMount
    setErrors({});
  }, []);

  const save = async (e, tokenData) => {
    setSaving(true);
    try {
      await tokens.revokeTokensForEmails(tokenData);
      setSaving(false);
      setErrors({});
    } catch ({ name, errors }) {
      setSaving(false);
      setErrors(errors);
      if (name !== 'BadRequestError') {
        logger.error('Error revoking tokens for emails', errors);
      }
    }
  };

  return (
    <BlockPanel open title="Revoke Tokens">
      <RevokeForm
        readOnly={saving}
        onCancel={() => history.push('/applications')}
        onSubmit={save}
        errors={errors}
      />
    </BlockPanel>
  );
}

RevokePage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default RevokePage;
